/**
 * Shared reveal-on-enter plugin — opacity 0→1 + rise from below.
 *
 * Attributes:
 *   data-reveal              enable (presence or "true")
 *   data-reveal-offset       start translateY px (default 50)
 *   data-reveal-duration     ms (default 500)
 *   data-reveal-delay        ms (default 0)
 *   data-reveal-once         "false" to replay (default once)
 */
(function () {
  'use strict';

  var ATTR = 'data-reveal';
  var INIT_KEY = 'hpRevealInit';
  var VISIBLE = 'is-revealed';
  var observer = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseNumber(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function applyVars(el) {
    var offset = parseNumber(el.getAttribute('data-reveal-offset'), 50);
    var duration = parseNumber(el.getAttribute('data-reveal-duration'), 500);
    var delay = parseNumber(el.getAttribute('data-reveal-delay'), 0);
    el.style.setProperty('--hp-reveal-offset', offset + 'px');
    el.style.setProperty('--hp-reveal-duration', duration + 'ms');
    el.style.setProperty('--hp-reveal-delay', delay + 'ms');
  }

  function reveal(el) {
    el.classList.add(VISIBLE);
  }

  function reset(el) {
    el.classList.remove(VISIBLE);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      var once = el.getAttribute('data-reveal-once') !== 'false';

      if (entry.isIntersecting) {
        reveal(el);
        if (once && observer) observer.unobserve(el);
      } else if (!once) {
        reset(el);
      }
    });
  }

  function ensureObserver() {
    if (observer || !window.IntersectionObserver) return observer;
    observer = new IntersectionObserver(onIntersect, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });
    return observer;
  }

  function collect() {
    var nodes = document.querySelectorAll('[' + ATTR + ']');
    var reduced = prefersReducedMotion();
    var obs = ensureObserver();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var raw = el.getAttribute(ATTR);
      if (raw !== null && raw !== '' && raw !== 'true') continue;

      applyVars(el);

      if (reduced) {
        reveal(el);
        continue;
      }

      if (!obs) {
        reveal(el);
        continue;
      }

      obs.observe(el);
    }
  }

  function init() {
    collect();
  }

  if (!window[INIT_KEY]) {
    window[INIT_KEY] = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  }
})();
